import { axiosHelper } from '../../..';
import { AxiosMethods } from '../../../../enums';

enum AnalyticsKeys {
  Create = 'create-analytics',
  CreateDB = 'create-databricks-analytics'
}

export const captureAnalyticsMutation = () => ({
  mutationKey: [AnalyticsKeys.Create],
  mutationFn: ({
    body,
    endpoint
  }: {
    body: { [key: string]: any };
    endpoint: string;
  }) =>
    axiosHelper({
      endpoint,
      method: AxiosMethods.POST,
      baseURL: process.env.REVOPS_API,
      body
    })
});

export const captureDBAnalyticsMutation = () => ({
  mutationKey: [AnalyticsKeys.CreateDB],
  mutationFn: (body: { [key: string]: any }) =>
    axiosHelper({
      endpoint: '/analytics/v2',
      method: AxiosMethods.POST,
      baseURL: process.env.REVOPS_API,
      body
    })
});
